import React from 'react'
import { useRecurringExportContext } from 'hooks/context/useRecurringExportContext'
import { RecurringExportSteps } from 'types/transactionsExport'
import { RecurringExportForm } from './components/RecurringExportForm'
import { RecurringExportList } from './components/RecurringExportList'

interface RecurringTransactionsExportType {
  downloadAll: boolean
}

export const RecurringTransactionsExport = ({ downloadAll }: RecurringTransactionsExportType) => {
  const { step } = useRecurringExportContext()

  return (
    <>
      {step === RecurringExportSteps.LIST && <RecurringExportList />}
      {step === RecurringExportSteps.FORM && <RecurringExportForm downloadAll={downloadAll} />}
    </>
  )
}
